import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { SelectItem } from 'primeng/api/selectitem';
import { Chronometer } from 'ngx-chronometer';
import { ContenusService } from 'src/app/services/contenus.service';
import { ModerationService } from 'src/app/services/moderation.service';
import { MessageService } from 'primeng/api';
import { CountdownComponent, CountdownConfig } from 'ngx-countdown';
import { Moderation } from 'src/app/classes/moderation';
import { DateCalculationService } from 'src/app/services/date-calculation.service';
import { GpaoService } from 'src/app/services/gpao.service';
import { HistoriqueService } from 'src/app/services/historique.service';
import { EncryptionService } from 'src/app/services/encryption.service';

@Component({
  selector: 'app-contenus',
  templateUrl: './contenus.component.html',
  styleUrls: ['./contenus.component.css'],
  providers : [MessageService]
})
export class ContenusComponent implements OnInit,OnDestroy {

  @ViewChild('cd', {static:false}) private countdown : CountdownComponent;

  // LIMITER
  config : CountdownConfig = {};
  intervalEvent : any;

  isOk : boolean = true;
  user : Object = {};
  detailsPtl : Object = {};
  idModeration: number;
  validationDescription : boolean;
  siteWeb : Object = {};
  description : Object = {};
  logo : Object = {};
  reseauxSociaux : Object[] = [];
  photos : Object[] = [];
  offre : Object = {};
  titreBonPlan : Object =  {};
  phraseAccroche : Object = {};
  detail : object = {};
  doute : boolean = false;
  disabled : boolean = false;
  disableSelectionPause : boolean = false;
  nbContenu : number = 0;
  dureeLastEnregistrement : number = 0;

  /**
   * Variables pause
   */
  pause: boolean = false;
  selectedPause: string ;
  pauseItem: SelectItem[] = [
    {label: 'Pause toilette', value: "9"},
    {label: 'Pause déjeuner', value: "4"},
    {label: 'Formation pratique', value: "23"},
    {label: 'Formation théorique', value: "2"},
    {label: 'ABSENCE : Funhece interne', value: "11"},
    {label: 'ABSENCE : Funhece externe', value: "2"}
  ];

  chrono: Chronometer = new Chronometer();
  chronoPause: Chronometer = new Chronometer();
  chronoNegatif: Chronometer = new Chronometer();
  boolIsNegatif = false;


  collapseSite : boolean = false;
  collapseDescription : boolean = false;
  collapseRs : any = {};
  collapsePhoto : any = {};
  collapseLogo : boolean = false;
  collapseTitreBonPlan : boolean = false;
  collapsePhraseAccroche : boolean = false;
  collapseDetails : boolean = false;


  constructor(private router: Router, private gpaoService: GpaoService, private contenusService: ContenusService, private dateService : DateCalculationService, private moderationService : ModerationService, private activatedRoute: ActivatedRoute, private msgService : MessageService, private historiqueService : HistoriqueService,private encryptService:EncryptionService) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
   }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.idModeration = params.moderation;
    });

    this.user = JSON.parse(this.encryptService.decrypt(localStorage.getItem("user")));

    this.moderationService.getDetailsPtl(this.idModeration).subscribe( value => {
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + value["cause"]);
      }else {

        this.detailsPtl = value["data"];

        if( (parseInt(this.detailsPtl["id_etat"]) !== 2) && (parseInt(this.detailsPtl["id_etat"]) !== 8) && (parseInt(this.detailsPtl["id_etat"]) !== 11)  ) {
          this.router.navigate(['/moderation']);
        }

        if( parseInt(this.detailsPtl["operateur"]) !== parseInt(this.user["matricule"]) ) {
          this.navigateNext(0);
        }

        if((parseInt(this.detailsPtl["id_etat"]) === 11)) {
          this.historiqueService.getLastTraitement(this.idModeration).subscribe( duree => {
            if(duree["status"] !== "success"){
              console.log("Une erreur dans la requête:" + duree["cause"]);
            } else {
              let dureeAction = (parseInt(duree['data'].duree_action));
              this.setCountdownOnInit(dureeAction);
              this.dureeLastEnregistrement = dureeAction;
            }
          });
        } else if((parseInt(this.detailsPtl["id_etat"]) === 8)) {
          this.historiqueService.getLastValidation(this.idModeration).subscribe( duree => {
            if(duree["status"] !== "success"){
              console.log("Une erreur dans la requête:" + duree["cause"]);
            } else {
              let dureeAction = (parseInt(duree['data'].duree_action));
              this.setCountdownOnInit(dureeAction);
              this.dureeLastEnregistrement = dureeAction;
              console.log(dureeAction);
              console.log(this.dureeLastEnregistrement);
            }
          });
        } else {
          this.setCountdownOnInit();
        }

        
      }
    });

    this.contenusService.recupererContenusCq(this.idModeration).subscribe(value => {

      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + value["cause"]);
      }else {
        let input = value["data"];

        if(localStorage.getItem("contenus") !== null && localStorage.getItem("contenus") !== undefined) { //=> si il reste une savegarde d'etat (ce qui veut dire que la page a juste été rechargée)
          let parsedContents = JSON.parse(localStorage.getItem("contenus"));
          let contenus = parsedContents.contenus;
          let idModeParsed = parseInt(parsedContents.idModeration);
          if(idModeParsed == this.idModeration) {
            this.nbContenu = contenus.length;
            this.trierContenus(contenus);
          } else {
            this.trierContenus(input);
          }

        }else {
          this.trierContenus(input);
        }

      }

    });

    this.setChronoOnInit();
    this.InitValuenegatif();
    if(localStorage.getItem("pause") !== null && localStorage.getItem("pause") !== undefined && localStorage.getItem("selected_pause") !== null && localStorage.getItem("selected_pause") !== undefined) {
      let pauseStocker = localStorage.getItem("pause");
      let selected = localStorage.getItem("selected_pause");
      let chrono_pause = localStorage.getItem("duree_pause");
      (chrono_pause === null || chrono_pause === undefined) ? chrono_pause : chrono_pause = "0";
      if(pauseStocker === "true" ) {
        this.pause = true;
        this.selectedPause = selected;
        this.disableSelectionPause = true;
        this.chronoPause.second =  parseInt(chrono_pause);
        this.chronoPause.start();
        this.chrono.pause();
      }
    }


  }


  ngOnDestroy(): void {
    clearInterval(this.intervalEvent);
  }

  /**
   * Trie les contenus selon leur type pour les placer dans leur variable respectif
   */
  trierContenus(input) {
    input.forEach(current => {
      switch(current.designation_type) {
        case 'lien site web' : {
          this.siteWeb = current;
          this.collapseSite = (current.is_valid_cq === true) ? true : false;
          break;
        }

        case 'descriptif PTL' : {
          this.description = current;
          this.collapseDescription = (current.is_valid_cq === true) ? true : false;
          break;
        }

        case 'logo' : {
          this.logo = current;
          this.collapseLogo = (current.is_valid_cq === true) ? true : false;
          break;
        }

        case 'lien reseaux sociaux' : {
          this.reseauxSociaux.push(current);
          this.collapseRs[current.id_contenu]  = (current.is_valid_cq === true) ? true : false;
          break;
        }

        case 'photo' : {
          this.photos.push(current);
          this.collapsePhoto[current.id_contenu] = (current.is_valid_cq === true) ? true : false;
          break;
        }

        case 'offre bon plan' : {
          this.offre = current;
          break;
        }


        case 'titre bon plan' : {
          this.titreBonPlan = current;
          this.collapseTitreBonPlan = (current.is_valid_cq === true) ? true : false;
          break;
        }

        case 'phrase accroche' : {
          this.phraseAccroche = current;
          this.collapsePhraseAccroche = (current.is_valid_cq === true) ? true : false;
          break;
        }

        case 'detail' : {
          this.detail = current;
          this.collapseDetails = (current.is_valid_cq === true) ? true : false;
          break;
        }

        default : {

        }
      }
    });

  }


  setCountdownOnInit(dureeAction:number=0) {

    let leftTime = 0;
    switch(parseInt(this.detailsPtl['id_complexite'])) {
      case(1) : {
        leftTime = 94 - dureeAction   
        break;
      }

      case(2) : {
        leftTime = 173 - dureeAction;
        break;
      }

      case(3) : {
        leftTime = 302 - dureeAction;
        break;
      }
    }

    if(leftTime > 0) {
      this.config = {
        leftTime : leftTime
      };
    } else {
      this.config = {
        leftTime : 1
      };
      
      if((localStorage.getItem("countup")) === null || (localStorage.getItem("countup")) === undefined) {
        this.boolIsNegatif = true;
        this.chronoNegatif.second = Math.abs(leftTime);  
        this.chronoNegatif.start();
        localStorage.setItem('countdown', '0');
      } else {
        this.InitValuenegatif();
      }
      
    }

    if(localStorage.getItem("countdown") !== null) {
      let left = parseInt(localStorage.getItem("countdown"));
      this.config = {
        leftTime : left
      };
    }

    if(this.countdown) {
      this.countdown.begin();
    }

    if(!this.boolIsNegatif)
    {
      this.intervalEvent =  setInterval(() => {

            if(this.countdown !== undefined && this.countdown.left == 0)
            {
              this.boolIsNegatif = true;
              this.StartChronoNegatif();
              localStorage.setItem("countdown", (this.countdown.left / 1000).toString());
            }
            
          }, 1000);
    }

  }


  /**
   *
   * @param chronometer
   * Stocke la valeur du chrono à chaque seconde (permet de gérer le rechargement de page)
   */
  onChronoEvent(chronometer: Chronometer) {
    //console.log("event non pause");
    localStorage.setItem("second", chronometer.second.toString());
  }

  /**
   *
   * @param chronometer
   * Stocke la valeur du chrono à chaque seconde (permet de gérer le rechargement de page)
   */
  onChronoEventNegatif(chronometer: Chronometer) {
    //console.log("ChronoNegatif");
    //console.log(chronometer.second.toString());
    localStorage.setItem("countup", chronometer.second.toString());
    //localStorage.setItem("second", chronometer.second.toString());
  }

  /**
   *
   * @param chronometer
   * Stocke la valeur du chrono à chaque seconde (permet de gérer le rechargement de page)
   */
  onChronoPauseEvent(chronometer: Chronometer) {
    console.log("event pause")
    localStorage.setItem("duree_pause", chronometer.second.toString());
  }

  /***
   * Permet d'initialiser le chrono à l'initialisation de la page.
   * Si on a déjà une valeur c'est que la page a rechargée
   */
  setChronoOnInit() {
    if(localStorage.getItem("second") !== null) {
      this.chrono.second = parseInt(localStorage.getItem("second"));
    }
    this.chrono.start();
  }

  /**
   *
   * @param isValid
   * Met à jour la valeur is_valid de description à chaque fois que celle-ci change
   */
  setValidationDescription(isValid: boolean) {
    this.description["is_valid"] = isValid;
    this.saveToLocal();
  }


  /**
   *
   * @param isValid
   * Met à jour la valeur is_valid du titre bon plan à chaque fois que celui-ci change
   */
   setValidationTitreBP(isValid: boolean) {
    this.titreBonPlan["is_valid"] = isValid;
    this.saveToLocal();
  }


  /**
   *
   * @param isValid
   * Met à jour la valeur is_valid de la phrase d'accroche à chaque fois que celle-ci change
   */
   setValidationPhraseAccroche(isValid: boolean) {
    this.phraseAccroche["is_valid"] = isValid;
    this.saveToLocal();
  }

  /**
   *
   * @param isValid
   * Met à jour la valeur is_valid du titre bon plan à chaque fois que celui-ci change
   */
   setValidationDetail(isValid: boolean) {
    this.detail["is_valid"] = isValid;
    this.saveToLocal();
  }


  /**
   *
   * @param input
   * @param isSite //=> vérifie si le composant est un site ou non
   * Met à jour la valeur is_valid d'un contenu site web ou reseaux sociaux'
   */
  setURLValidity(isSite: boolean, input: Object) {
    if(!isSite) {
      this.reseauxSociaux.forEach(current => {
        if(current["id_contenu"] === input["id_contenu"]){
          current["is_valid"] = input["is_valid"];
        }
      });
    } else {
      this.siteWeb["is_valid"]  = input["is_valid"];

    }

    this.saveToLocal();
  }

  /**
   *
   * @param input
   * @param isSite //=> vérifie si le composant est un site ou non
   * Met à jour la valeur du lien d'un contenu site web ou reseaux sociaux'
   */
  setURLLink(isSite: boolean, input: Object) {
    if(!isSite) {
      this.reseauxSociaux.forEach(current => {
        if(current["id_contenu"] === input["id_contenu"]){
          current["valeur_contenu"] = input["lien"];
        }
      });
    } else {
      this.siteWeb["valeur_contenu"]  = input["lien"];
    }

    this.saveToLocal();
  }

  /**
   *
   * @param input
   * @param isSite //=> vérifie si le composant est un site ou non
   * Met à jour la valeur des motifs d'erreur d'un contenu site web ou reseaux sociaux'
   */
  setURLErrors(isSite: boolean, input: Object) {
    if(!isSite) {
      this.reseauxSociaux.forEach(current => {
        if(current["id_contenu"] === input["id_contenu"]){
          current["erreurs"] = input["erreurs"];
        }
      });
    } else {
      this.siteWeb["erreurs"]  = input["erreurs"];
    }
    this.saveToLocal();
  }

  /**
   *
   * @param valeurContenu
   * Met à jour la valeur valeur_contenu de description à chaque changement
   */
  descriptionChanged(valeurContenu: string) {
    this.description["valeur_contenu"] = valeurContenu;
    this.saveToLocal();
  }

  /**
   *
   * @param valeurContenu
   * Met à jour la valeur valeur_contenu de titreBonPlan à chaque changement
   */
   titreBPChanged(valeurContenu: string) {
    this.titreBonPlan["valeur_contenu"] = valeurContenu;
    this.saveToLocal();
  }

  /**
   *
   * @param valeurContenu
   * Met à jour la valeur valeur_contenu de phraseAccroche à chaque changement
   */
   phraseAccrocheChanged(valeurContenu: string) {
    this.phraseAccroche["valeur_contenu"] = valeurContenu;
    this.saveToLocal();
  }

  /**
   *
   * @param valeurContenu
   * Met à jour la valeur valeur_contenu de detail à chaque changement
   */
   detailChanged(valeurContenu: string) {
    this.detail["valeur_contenu"] = valeurContenu;
    this.saveToLocal();
  }


  /**
   *
   * @param erreurs
   * met à jour les motifs de KO de la descrition
   */
  erreursDescriptionChanged(erreurs: Object[]) {
    this.description["erreurs"] = erreurs;
    this.saveToLocal();
  }


  /**
   *
   * @param erreurs
   * met à jour les motifs de KO du titreBonPlan
   */
   erreursTitreBPChanged(erreurs: Object[]) {
    this.titreBonPlan["erreurs"] = erreurs;
    this.saveToLocal();
  }

  /**
   *
   * @param erreurs
   * met à jour les motifs de KO de la phrase d'accroche
   */
   erreursPhraseAccrocheChanged(erreurs: Object[]) {
    this.phraseAccroche["erreurs"] = erreurs;
    this.saveToLocal();
  }

  /**
   *
   * @param erreurs
   * met à jour les motifs de KO de la descrition
   */
   erreursDetailChanged(erreurs: Object[]) {
    this.detail["erreurs"] = erreurs;
    this.saveToLocal();
  }


  /**
   *
   * @param input
   * @param isLogo //=> vérifie si le composant est un logo ou non
   * Met à jour la valeur is_valid d'un contenu photo ou un contenu logo'
   */
  setMediaValidity(isLogo: boolean, input: Object) {
    if(!isLogo) {
      this.photos.forEach(current => {
        if(current["id_contenu"] === input["id_contenu"]){
          current["is_valid"] = input["is_valid"];
        }
      });
    } else {
      this.logo["is_valid"]  = input["is_valid"];
    }
    this.saveToLocal();
  }



  /**
   *
   * @param input
   * @param isLogo //=> vérifie si le composant est un logo ou non
   * Met à jour la valeur des motifs d'erreur d'un contenu logo ou photo'
   */
  setMediaErrors(isLogo: boolean, input: Object) {
    if(!isLogo) {
      this.photos.forEach(current => {
        if(current["id_contenu"] === input["id_contenu"]){
          current["erreurs"] = input["erreurs"];
        }
      });
    } else {
      this.logo["erreurs"]  = input["erreurs"];
    }

    this.saveToLocal();
  }




  /**
   * Cette fonction retourne un tableau rassemblant tous les contenus et leur etat actuel
   */
  assemblerContenus() : any[] {
    let options = [];

    if(this.siteWeb.hasOwnProperty("id_contenu")) options.push(this.siteWeb);
    if(this.logo.hasOwnProperty("id_contenu")) options.push(this.logo);
    if(this.description.hasOwnProperty("id_contenu")) options.push(this.description);
    if(this.titreBonPlan.hasOwnProperty("id_contenu")) options.push(this.titreBonPlan);
    if(this.detail.hasOwnProperty("id_contenu")) options.push(this.detail);
    if(this.phraseAccroche.hasOwnProperty("id_contenu")) options.push(this.phraseAccroche);


    if(this.reseauxSociaux.length > 0) {
      this.reseauxSociaux.forEach(current => {
        options.push(current);
      });
    }

    if(this.photos.length > 0) {
      this.photos.forEach(current => {
        options.push(current);
      });
    }

    return options;
  }




  /**
   * executé quand le traitement est terminée (on clique sur valider la modération)
   */
  nextTraitement(idAction : number, quitter:boolean=false) {
    this.disabled = true;
    let options = this.assemblerContenus();

    this.isOk = null;
    let ok = true;


    if(idAction !== 7 && idAction !== 8) ok = this.checkContenus(options); //=> si pas d'enregistrement
    
    if(ok) {
      let parameter = {
        'idModeration' : this.idModeration,
        'operateur' : this.user["matricule"],
        'action' : idAction,
        'contenus' : options,
        "duree" : (this.chrono.second + this.dureeLastEnregistrement),
        "is_ok" : this.isOk,
        "passe_cq" : this.detailsPtl["passe_cq"],
        "doute" : this.doute,
        "etat" : this.detailsPtl["id_etat"]
      };
      //let raw = String.raw`${JSON.stringify(parameter)}`;

      this.contenusService.validerTraitement(parameter).subscribe(value => {
        if(value["status"] !== "success"){
          console.log("Une erreur dans la requête:" + value["cause"]);
          alert("une erreur s'est produite, veuillez réessayer");
          this.disabled = false;
        }else {
          this.chrono.pause();

          clearInterval(this.intervalEvent);
          localStorage.removeItem("countdown");
          localStorage.removeItem("countup");
          localStorage.removeItem("second");
          localStorage.removeItem("contenus");

          if(quitter !== true ){
            this.navigateNext(idAction);
          } else {
            this.router.navigate(['/moderation']);
          }
        }
      });

    } else {
      this.disabled = false;
    }

  }


  /**
   * Permet de naviguer une fois le traitement fini ou si le ptl n'appartient pas à l'opérateur
   */
  navigateNext(idAction : number) {
    let mode = localStorage.getItem("mode");

    if(idAction === 7 ) { //si on fait un enregistrement simple on est redirigé vers une autre page

      this.router.navigate(["/historique"]);

    }else {
      //if(mode === "push") {
        /* this.moderationService.getNextTraitement("moderation").subscribe(value => {

          if(value["status"] !== "success"){
            console.log("Une erreur dans la requête:" + value["cause"]);
          }else {
            let input = value["data"];

            if(input["id_moderation"]) { //=> si on a des modifications à faire
              let options = {
                moderation : input["id_moderation"],
                operateur : this.user["matricule"],
                action : 1,
                etat : input["id_etat"]
              };

              this.moderationService.changerEtat(options).subscribe(value => {
                if(value["status"] !== "success"){
                  console.log("Une erreur dans la requête:" + JSON.stringify(value["cause"]));
                } else {
                  this.router.navigate(["/traitement", input["id_moderation"]] );
                }
              });

            }else {
              this.router.navigate(['/moderation']);
            }
          }

        }); */

        this.moderationService.getCurrentModerationLibres(parseInt(this.user["matricule"])).subscribe((value) => {
          if(value["status"] !== "success"){
            console.log("Une erreur dans la requête:" + value["cause"]);
          }else {
            let moderations : Moderation[] = [];
            let moderationList = value["data"];
            moderations = this.formatArray(moderationList);
            moderations.sort(this.sortByDuree);

            if(moderations.length > 0) { //=> si on a des modération à faire
              this.routeToNextDispo(moderations, 0);
            } else {
              this.router.navigate(['/moderation']);
            }
          }
        });
  
      // } else {
      //   this.router.navigate(['/moderation']);
      // }
    }


  }


  /**
   * fonction recursif de parcours de la liste de modération en entrée
   * Tans que le ptl est déjà pris on avance dans la liste
   * @param moderationListe
   * @param index
   */
  routeToNextDispo(moderations : Moderation[], index: number){
    if(index >= moderations.length) {
      this.router.navigate(['/moderation']);
    } else {
      let options = {
        moderation : moderations[index].idModeration,
        operateur : this.user["matricule"],
        action : 1,
        etat : moderations[index].idEtat
      };

      this.moderationService.changerEtat(options).subscribe(value => {
        if(value["status"] !== "success"){
          console.log("Une erreur dans la requête:" + JSON.stringify(value["cause"]));
          if(value["cause"] === "PTL déjà pris") {
            this.routeToNextDispo(moderations, (index + 1));
          } else if(value["cause"] === "En cours existant") {
            this.router.navigate(['/moderation']);
          }
        } else {
          this.router.navigate(["/traitement", moderations[0].idModeration] );
        }
      });
    }
  }

  /**
   * Cette fonction permet de formatter le tableaux retourné par l'api en format utilisable pour le tableau
   * type => 1: moderation, 2 : cq
   * @param moderationList
   */
  formatArray(moderationList : any[]) {
    let cumulArray : Moderation[] = [];

    moderationList.forEach(item => {
      let dateDelai: Date ;
      let now:Date = new Date();
      let delaiRestant:string;

      if(item.type_ptl === "INITIALE") {
        dateDelai = this.dateService.calculDelay(item.date_arrivee, 24);
      } else {
        dateDelai = this.dateService.calculDelay(item.date_arrivee, 2);
      }

      if(now.getTime() > dateDelai.getTime()){
        delaiRestant = "00:00";
      }else {
        delaiRestant = this.dateService.getDifference(now, dateDelai);
      }

      let mod : Moderation = {
        idModeration : item.id_moderation,
        numPointAccueil : item.num_point_accueil,
        numConvention : item.num_convention,
        numEncaisseur : item.num_encaisseur,
        typePtl : item.type_ptl,
        operateur : item.operateur,
        responsableCq : item.id_responsable_cq,
        idBonPlan : item.id_bon_plan,
        etat : item.etat,
        tempsRestant : delaiRestant,
        idEtat : item.id_etat,
        priorite : item.priorite,
        idComplexite : item.id_complexite,
        complexite : item.libelle_complexite
      };

      cumulArray.push(mod);
    });

    return cumulArray;
  }


  /**
   * Ordre des fiches par durée
   */
  sortByDuree(a : Moderation, b : Moderation) {
    if(a.tempsRestant > b.tempsRestant ) {
      return 1;
    } else if (a.tempsRestant < b.tempsRestant ){
      return -1;
    } else {
      return 0;
    }
  }


  annulerTraitement() {
    this.disabled = true;
    let user = JSON.parse(this.encryptService.decrypt(localStorage.getItem("user")));
    let options = {
      moderation : this.idModeration,
      operateur : user.matricule,
      action : 3,
      etat : this.detailsPtl["id_etat"],
      typeAction : 2,
      typePtl : this.detailsPtl["id_type_ptl"]
    };

    this.moderationService.annulerTraitement(options).subscribe(value => {
      if(value["status"] !== "success"){
        console.log("Une erreur dans la requête:" + JSON.stringify(value["cause"]));
        this.disabled = false;
      } else {
        clearInterval(this.intervalEvent);
        localStorage.removeItem("countdown");
        localStorage.removeItem("second");
        localStorage.removeItem("contenus");
        this.router.navigate(["/moderation"]);
      }
    });
  }

  /**
   * executé en début de pause
   */
  beginPause(){
    this.pause = true;
  }


  pauseChoisi() {
    this.disableSelectionPause = true;
    this.chrono.pause();
    this.countdown.pause();
    this.chronoPause.start();

    localStorage.setItem("pause", 'true');
    localStorage.setItem('selected_pause', this.selectedPause.toString());

    let options = {
      idResponsable : this.user['matricule'],
      dateArrivee : this.detailsPtl['date_arrivee'],
      etape : 5122,
      idTypeLdt : parseInt(this.selectedPause),
      numPointAccueil : this.detailsPtl['num_point_accueil'],
      typePtl : this.detailsPtl['type_ptl'],
      nbContenu : this.nbContenu,
      idMotifLot : 1
    };

    console.log(options);
    this.gpaoService.debutLigne(options).subscribe(value => {
      if(value["status"] !== "success") console.log('erreur 500');
    })

  }

  /**
   * executé en fin de pause
   */
  endPause(){
    let options = {
      idResponsable : this.user['matricule'],
      dateArrivee : this.detailsPtl['date_arrivee'],
      etape : 5122,
      idTypeLdt : 0,
      numPointAccueil : this.detailsPtl['num_point_accueil'],
      typePtl : this.detailsPtl['type_ptl'],
      nbContenu : 0,
      idMotifLot : 1
    };

    this.gpaoService.finLigne(options).subscribe(value => {
      if(value["status"] !== "success") console.log('erreur 500');
    });

    this.pause = false;
    this.chrono.start();
    this.countdown.resume();
    this.chronoPause.pause();
    this.selectedPause= "";
    this.chronoPause.stop();
    this.disableSelectionPause = false;
    localStorage.removeItem("pause");
    localStorage.removeItem("selected_pause");
  }



  /**
   * Bouton fin pause clickable ou pas => l'user doit choisir une raison de pause
   */
  endPauseClickable() {
    if(this.pause === true && this.selectedPause !== "" && this.selectedPause !== undefined && this.selectedPause !== null){
      return false;
    }
    return true;
  }

  /**
   * Vérifie si les contenus sont bons (les KO avec motifs et pas de contenus non traité)
   */
  checkContenus(contenus : any[] ) : boolean {
    let result = true;

    contenus.forEach(currentContenu => {

        if(currentContenu['doute'] === false || currentContenu['doute'] === null ) {
          
          if(currentContenu.is_valid === null) {
            result = false;
            this.errorContenu(currentContenu, "Contenu non modéré");
          }else if(currentContenu.is_valid === false) {
            if( !currentContenu["erreurs"] || currentContenu["erreurs"].length === 0) {
              result = false;
              this.errorContenu(currentContenu, "KO mais sans motif");
            }
            this.isOk = false;
          } else {
            if(this.isOk === null) this.isOk = true;
          }

        }  else {
          this.doute = true;
          this.isOk = false;
        }
    });

    return result;
  }


  errorContenu(contenu : Object , detail: string) {
    this.msgService.add({
      severity:'error',
      summary:'Contenu de type ' + contenu["designation_type"] + " : " + detail,
      detail: 'Contenu : ' + contenu["valeur_contenu"]
    });
  }


  /**
   * Sauvegarde l'etat de la fiche dans le localstorage pour prévenir des recharges de page
   */
  saveToLocal() {
    let contenus = this.assemblerContenus();
    let stringified = {
      idModeration : this.idModeration,
      contenus : contenus
    }
    localStorage.setItem('contenus', JSON.stringify(stringified));
  }





  contenuDouteUpdated(input : Object) {

    switch(input['type']) {

      case('description') : {
        this.description['doute'] = input["doute"];
        break;
      }

      case('site') : {
        this.siteWeb['doute'] = input['doute'];
        break;
      }

      case('logo') : {
        this.logo['doute'] = input['doute'];
        break;
      }

      case('titreBonPlan') : {
        this.titreBonPlan['doute'] = input['doute'];
        break;
      }

      case('phraseAccroche') : {
        this.phraseAccroche['doute'] = input['doute'];
        break;
      }

      case('detail') : {
        this.detail['doute'] = input['doute'];
        break;
      }

      case('photo') : {
        this.photos.forEach( photo => {
          if(photo["numero_contenu"] === input['numContenu']) {
            photo['doute'] = input['doute'];
          }
        });

        break;
      }


      case('reseaux') : {

        this.reseauxSociaux.forEach(rs => {
          if(rs['numero_contenu'] === input['numContenu']) {
            rs['doute'] = input['doute'];
          }
        });

        break;
      }


    }

    this.saveToLocal();

  }
  // FOnction Lancement Negatif
  StartChronoNegatif()
  {
    this.chronoNegatif.start();
  }

  // Fonction Initialisation Donnee LocalStorage Negatif
  InitValuenegatif()
  {
      let left = (localStorage.getItem('countdown')) ? parseInt(localStorage.getItem("countdown")) : 0;
      console.log("INIt"+left);
      if(localStorage.getItem("countdown") === null ) {
        left = 1;
      }
      if(left === 0)
      {
        this.boolIsNegatif = true;
        if(localStorage.getItem("second") !== null) {
          this.chronoNegatif.second = parseInt(localStorage.getItem("countup"));
        }
        this.chronoNegatif.start();
      }
  }


  verifierEnseigne () {
    let contenu = this.detailsPtl["enseigne_guide"];
    contenu = "https://www.google.com/search?q=" + escape(contenu);
    contenu = contenu.replace(/%u0153/g, 'oe');
    contenu = contenu.replace(/%u2019/g, '\'');
    //var url = encodeURI(contenu);
    window.open(contenu, "_blank");
  }


  getIfRetour() {
    return (parseInt(this.detailsPtl['id_type_ptl']) === 1) ? false : true;
  }

  checkIfToCollapse(validCq:boolean) {
    console.log(validCq)
    if(this.detailsPtl['etat'] === 8 && validCq === true) {
      return true;
    } else {
      return false;
    }
  } 

}
